const Z_INDEXES = {
  base: 0,
  header: 200,
  modal: 300,
  modalGlobal: 500,
  notification: 1000,
};

export default Z_INDEXES;
